import BranchContainer from './containers/Branch';
import BranchComponent from './components/Branch';

export default BranchContainer(BranchComponent);



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/branch/index.js